import { routes } from "../../routers/routes";
import { IconLinkList } from "../../types/CommonComponents";
import { LanguagesList, MenuItemType } from "../../types/Layout";

export const Cities: string[] = ["Amsterdam", "Ankara", "Athens", "Atlantic", "Baltimore", "Bangkok", "Beijing", "Berlin", "Berne", "Brussels", "Budapest", "Buenos Aires", "Cairo", "Canberra", "Cannes", "Cape Town", "Chicago", "Cologne", "Copenhagen", "Damascus", "Delhi", "Dubai", "Dublin", "Florence", "Hague", "Havana", "Helsinki", "Hong Kong", "Honolulu", "Istanbul", "Jakarta", "Jerusalem", "Kansas City", "Kathmandu", "Kuala Lumpur", "Lisbon", "London", "Los Angeles", "Luxembourg", "Madrid", "Manila", "Melbourne", "Milan", "Montreal", "Moscow", "Munich", "Nazareth", "New York", "Nice", "Osaka", "Ottawa", "Paris", "Philadelphia", "Phnom Penh", "Prague", "Quito", "Reykjavik", "Rio de Janeiro", "San Francisco", "Santa Fe", "Santiago", "Shanghai", "Singapore City", "Stockholm", "Saint Petersburg", "Seoul", "Sydney", "Taipei", "Toronto", "Venice", "Vienna", "Washington", "Armenia", "Argentina", "Australia", "Aruba", "Belize", "Burundi", "Cape Verde", "Wokha", "Chile", "Ethiopia", "Zunheboto"];

export const MenuItem: MenuItemType[] = [
  {
    title: "Home",
    active: false,
    path: routes.Home.CarDemo1,
    type: "link",
  },
  {
    title: "Inventory",
    active: false,
    path: routes.Car.Listing.CarLeftList,
    type: "link",
  },
  {
    title: "Our Services",
    type: "sub",
    active: false,
    path: '',
    // path: routes.Pages.Other.Services1,
    children: [
      {
        title: "Sell Your Car",
        path: routes.Pages.Other.ContactUs2,
        type: "link",
      },
      {
        title: "Consign With Us",
        path: routes.Pages.Other.ConsignWithUs,
        type: "link",
      },
      {
        title: "JPJ Services",
        path: routes.Pages.Other.JPJ,
        type: "link",
      },
      {
        title: "Loan Calculator",
        path: routes.Car.Other.CarLoanCalculator,
        type: "link",
      },
    ],
  },
  {
    title: "About Us",
    type: "sub",
    active: false,
    path: '',
    children: [
      {
        title: "About Us",
        path: routes.Pages.Other.AboutUs1,
        type: "link",
      },
      {
        title: "Our Journey",
        path: routes.Pages.Other.OurJourney,
        type: "link",
      },
    ],
  },
  {
    title: "Contact Us",
    active: false,
    path: routes.Pages.Other.ContactUs3,
    type: "link",
  },
];

export const AccountData: string[] = ["All Rides", "My Account", "Saved Rides", "Privacy", "Searches", "Recommendations", "My Profile"];

export const LanguagesData: LanguagesList[] = [
  { data: "en", language: "English" },
  { data: "sp", language: "Spanish" },
  { data: "fr", language: "French" },
  { data: "ge", language: "German" },
  { data: "ko", language: "Korean" },
];

export const SocialLinks: IconLinkList[] = [
  { url: "https://www.facebook.com/", icon: "ri-facebook-fill" },
  { url: "https://x.com/", icon: "ri-twitter-x-line" },
  { url: "https://www.instagram.com/", icon: "ri-instagram-line" },
  { url: "https://www.youtube.com/", icon: "ri-youtube-fill" },
];

export const HeaderClassMap: { [key: string]: string } = {
  "car-2": " car-top-header",
  job: " job-header",
  "job-2": " dark-job-header",
  "job-3": " job3-header",
  "property-2": " position-relative p-0",
};

export const ContainerClassMap: { [key: string]: string } = {
  "car-2": "car2-header",
  "property-2": "property2-header",
};
